import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { OrdersService } from '../../../api/orders.service';
import { SpecificConditionService } from '../../../api/specific-condision.service';
import { NGXLogger } from 'ngx-logger';
import { ToastrService } from 'ngx-toastr';
import { FuseTranslationLoaderService } from '../../../../../@fuse/services/translation-loader.service';
import { GT2PageAbstract } from '../../../content/abstract/GT2PageAbstract';
import { locale as english } from './i18n/en-CA';
import { locale as french } from './i18n/fr-CA';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { AddSpecificConditionPanelService } from '../../../services/add-specific-condition-panel.service';
import { WrappingService } from '../../../api/wrapping.service';
import { ProposalComposeService } from '../../../api/proposal-compose.service';
import { ProposalComposeCTService } from '../../../api/proposal-compose-ct.service';
import { OrderComposeService } from '../../../api/order-compose.service';
import { InvoiceComposeService } from '../../../api/invoice-compose.service';
import { InvoiceComposeCTService } from '../../../api/invoice-compose-ct.service';
import { InvoiceComposeGlobalPaymentsService } from '../../../api/invoice-compose-global-payments.service';
import { CatererService } from '../../../content/caterer/caterer.service';
import { ConseillersService } from '../../../api/conseillers.service';
import { ReportsService } from '../../../reports/reports.service';
import { ReportFactoryService } from '../../../reports/report-factory.service';
import { MenuReportsService } from '../../../reports/menu-reports.service';
import { ReceiptNoticeComposeService } from '../../../api/receipt-notice-compose.service';
import { ReceiptNoticeSellOnlyComposeService } from '../../../api/receipt-notice-sell-only-compose.service';
import { StorageNoticeComposeService } from '../../../api/storage-notice-compose.service';
import { Gt2SelectComponent } from '../../gt2-select/gt2-select.component';
@Component({
  selector: 'app-add-specific-condition',
  templateUrl: './add-specific-condition.component.html',
  standalone: true,
  imports: [
    Gt2SelectComponent,
    MatProgressSpinnerModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    TranslateModule,
    CommonModule,
  ],
  providers: [
    WrappingService,
    SpecificConditionService,
    ProposalComposeService,
    ProposalComposeCTService,
    OrderComposeService,
    InvoiceComposeService,
    InvoiceComposeCTService,
    InvoiceComposeGlobalPaymentsService,
    CatererService,
    ConseillersService,
    ReportsService,
    ReportFactoryService,
    MenuReportsService,
    ReceiptNoticeComposeService,
    ReceiptNoticeSellOnlyComposeService,
    StorageNoticeComposeService,
  ],
  styleUrls: ['./add-specific-condition.component.scss'],
})
export class AddSpecificConditionComponent
  extends GT2PageAbstract
  implements OnInit, AfterViewInit, OnDestroy
{
  static CREATE: string = 'CREATE';
  static EDIT: string = 'EDIT';

  //
  mode: string = AddSpecificConditionComponent.CREATE;
  // form: FormGroup;
  // specificCondition: any;
  orderUUID!: string;
  // order: any;
  override loading: boolean = false;
  autoRedirect: boolean = false;
  specificConditions?: any[];
  selectedSpecificCondition: any;
  // specificConditionToUpdate: any;
  // specificConditionData: any;

  constructor(
    private addPanelService: AddSpecificConditionPanelService,
    private translationLoader: FuseTranslationLoaderService,
    public translate: TranslateService,
    public specificConditionService: SpecificConditionService,
    public orderService: OrdersService,
    public dialog: MatDialog,
    public router: Router,
    private adapter: DateAdapter<any>,
    private toastr: ToastrService,
    private logger: NGXLogger,
  ) {
    super();
    this.translationLoader.loadTranslations(english, french);
    this.adapter.setLocale(this.translate.currentLang);

    const addData = this.addPanelService.getData();
    if (addData) {
      this.mode = AddSpecificConditionComponent.CREATE;
      this.orderUUID = addData.orderUUID;
      this.autoRedirect = addData.autoRedirect ?? false;
    }
  }

  ngOnInit() {}

  ngAfterViewInit() {}

  ngOnDestroy() {}

  public onCreateSpecificCondition(addAnother: boolean = false) {
    this.loading = true;
    // this.logger.info("AddSpecificConditionComponent.onCreateSpecificCondition() -> flow: " + JSON.stringify(this.selectedSpecificCondition));

    if (this.mode === AddSpecificConditionComponent.CREATE) {
      this.doCreateSpecificCondition(addAnother);
    } else if (this.mode === AddSpecificConditionComponent.EDIT) {
      this.updateSpecificCondition();
    }
  }

  public doCreateSpecificCondition(addAnother: boolean = false) {
    //this.logger.info("AddSpecificConditionComponent.doCreateSpecificCondition() -> selectedSpecificCondition: " + JSON.stringify({ service_charge: [this.selectedSpecificCondition] }));
    this.orderService
      .addSpecificCondition(this.orderUUID, {
        specific_condition: [this.selectedSpecificCondition],
      })
      .subscribe({
        next: (response: any) => {
          this.loading = false;
          if (addAnother) {
            this.addPanelService.emitIntermediateResult(response.data);
            this.toastr.success(
              '',
              this.translate.instant('SPECIFIC_CONDITION.CREATED'),
            );
            this.selectedSpecificCondition = null;
          } else {
            this.addPanelService.emitResult(response.data);
          }
        },
        error: (error: any) => {
          this.logger.error(
            'AddSpecificConditionComponent.doCreateSpecificCondition() -> ERROR: ' +
              JSON.stringify(error),
          );
          this.loading = false;
          this.handleAPIError(
            error,
            this.dialog,
            this.toastr,
            this.translate.instant('GENERIC.ERRORS.GENERIC') + ' SC001',
            this.router,
          );
          // this.toastr.error(this.translate.instant("GENERIC.ERRORS.GENERIC"));
        },
      });
  }

  public updateSpecificCondition() {
    //this.logger.info("AddSpecificConditionComponent.updateSpecificCondition() -> ***** UPDATE this.selectedSpecificCondition: " + JSON.stringify(this.selectedSpecificCondition));
    //   this.orderService.updateServiceCharge(this.deliveryRequest, this.eventUUID).subscribe(response => {
    //     this.logger.info("AddServiceChargeComponent.onCreateFlow() -> SUCCESS: " + JSON.stringify(response));
    //     this.loading = false;
    //     this.dialogRef.close(response);
    //   }, error => {
    //       this.logger.error("AddServiceChargeComponent.onCreateFlow() -> ERROR: " + JSON.stringify(error));
    //       this.loading = false;
    //       this.handleAPIError( error, this.dialog);
    //       this.toastr.error(this.translate.instant("GENERIC.ERRORS.GENERIC"));
    //     });
    // }
  }

  public onSpecificConditioneChange(event: any): void {
    this.selectedSpecificCondition = event;
  }

  public close(): void {
    this.addPanelService.emitResult(false);
  }
}
